// Inspired By: https://github.com/stimulus-components/stimulus-dropdown/blob/master/src/index.ts
import UIPopover from "controllers/ui/popover_controller";
// import { useTransition } from "stimulus-use";

export default class extends UIPopover {}
